import { Box, ButtonBase, Stack, styled, Tab, Tabs } from "@mui/material"
import { TitleBox, TypographyOutline } from "../pages/mobile/styled"
import { useEffect, useState } from "react"
import FlexRowAlign from "./flexbox/FlexRowAlign"
import zIndex from "@mui/material/styles/zIndex"

export const AppTabs = ({ sx, className, onChange, titles = [], icons, defaultIndex }) => {
    const [value, setValue] = useState(0)
    const handleChange = (index) => {
        if (onChange) onChange(index)
        setValue(index)
    }
    useEffect(() => {
        setValue(defaultIndex || 0)
    }, [defaultIndex])
    return <Stack>
        <TabContainer>
            <FlexRowAlign sx={{ zIndex: 2, padding: '8px' }}>
                {
                    titles.map((title, index) => <TabItem className={value === index ? 'active' : ''} sx={{ paddingRight: icons?.[index] ? '5px' : 0 }} key={title} onClick={() => handleChange(index)}>
                        {icons?.[index]}
                        {title}
                    </TabItem>)
                }
            </FlexRowAlign>
        </TabContainer>
    </Stack>
}
const TabContainer = styled(Stack)(({ theme }) => ({
    borderRadius: '0.3rem',
    width: '100%',
    marginTop: '2px',
    position: 'relative',
    zIndex: 2,
    '&:before': {
        content: '""',
        width: 'calc(100% - 3px)',
        height: 'calc(100% - 3px)',
        position: 'absolute',
        top: '1.5px',
        left: '1.5px',
        zIndex: 1,
        background: '#3a2e1e',
        borderRadius: '0.3rem',
        border: '1px solid #000'
    },
    '&:after': {
        content: '""',
        width: '100%',
        height: '100%',
        position: 'absolute',
        zIndex: 0,
        background: 'rgba(255,255,255,0.2)',
        borderRadius: '0.4rem',
    }
}));

const TabItem = styled(ButtonBase)(({ theme }) => ({
    height: 35,
    width: '100%',
    textShadow: '0px 0px 1px #000',
    border: '1px solid transparent',
    borderRadius: '0.3rem',
    fontSize: '1.1rem',
    gap: '5px',
    '&.active': {
        background: '#785A3E',
        borderColor: '#C4AA7C'
    }
}));

